export const environment = {
  production: true,
  estado: '💪 Production!',
  url_api: 'https://api.education.gofeels.com/api/v1',
  url_base: 'https://reservation.education.gofeels.com',
};
